jQuery(document).ready(function ($) {
  headerFull($);
  buscaMobile($);
  // buscaDesktop($);
});

/* =================== HEADER FULL =================== */
function headerFull($) {
  const header = $(".header-full");
  if (header.length > 0) {
    function toggleHeaderFull() {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > 100) {
        header.addClass("active");
      } else {
        header.removeClass("active");
      }
    }
    toggleHeaderFull();
    $(window).on(
      "scroll",
      debounce(function () {
        toggleHeaderFull();
      }, 10)
    );
  }
}

/* =================== BUSCA DESKTOP =================== */
// function buscaDesktop($) {
//   $("button", "#form-busca").on("click", function (e) {
//     if (!$("input", "#form-busca").hasClass("ativo")) {
//       e.preventDefault();
//       $("input", "#form-busca").trigger("focus").toggleClass("ativo");
//     }
//   });

//   $("input", "#form-busca").on("focusout", function (e) {
//     $(this).toggleClass("ativo");
//   });
// }

/* =================== BUSCA MOBILE =================== */
function buscaMobile($) {
  $(".btn-busca", ".menu-mobile-botoes").on("click", function () {
    const eBuscaWrap = $(".busca-wrap", ".busca-mobile");
    const eBuscaMobile = $(".busca-mobile");
    const height_busca = eBuscaWrap.height();

    if (!eBuscaMobile.hasClass("active")) {
      eBuscaMobile
        .animate(
          {
            height: height_busca,
          },
          600
        )
        .addClass("active");
    } else {
      eBuscaMobile
        .animate(
          {
            height: 0,
          },
          600
        )
        .removeClass("active");
    }
  });
}
